import {
	CardHeader,
	CardTitle,
	CardContent,
	Button,
} from "@/components/primitives";
import { ArrowRight, Target } from "lucide-react";

interface CorrectiveActionsIntroStepProps {
	onContinue: () => void;
}

export function CorrectiveActionsIntroStep({
	onContinue,
}: CorrectiveActionsIntroStepProps) {
	return (
		<>
			<CardHeader className="pb-4 border-b bg-gradient-to-r from-blue-50/50 to-indigo-50/50 dark:from-blue-950/20 dark:to-indigo-950/20">
				<div className="flex items-center gap-3">
					<div className="p-2 rounded-lg bg-gradient-to-br from-green-500 to-emerald-600">
						<Target className="h-5 w-5 text-white" />
					</div>
					<div>
						<CardTitle className="text-xl sm:text-2xl font-semibold">
							Corrective Actions
						</CardTitle>
					</div>
				</div>
			</CardHeader>
			<CardContent className="pt-6">
				<div className="space-y-4">
					<p className="text-muted-foreground leading-relaxed">
						Next, we'll suggest some potential corrective actions
					</p>
					<p className="text-muted-foreground leading-relaxed">
						Choose the ones that feel most aligned with your reflection and that
						you believe could truly make a difference.
					</p>
					<p className="text-muted-foreground leading-relaxed mb-6">
						'Corrective actions' are practical steps you can take to address the
						signals and contributing factors impacting your stress.
					</p>
					<p className="text-sm text-muted-foreground mb-8">
						For a reminder of your reflection at any point press the light bulb
						button at the top right.
					</p>
					<div className="text-center">
						<Button
							onClick={onContinue}
							size="lg"
							className="bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white shadow-md hover:shadow-lg transition-all"
						>
							Next
							<ArrowRight className="h-4 w-4 ml-2" />
						</Button>
					</div>
				</div>
			</CardContent>
		</>
	);
}
